import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../constants/styles';
import { TranslationHelpers } from '../../../../i18n/translationHelpers';
import { findClosestFullEmail } from './domainSuggestionUtils';

const Suggestion = styled.div`
    font-size: 12px;
    margin-top: 5px;
    color: ${COLORS.yellow};
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    width: 100%;
`;
const StrongText = styled.strong`
    font-weight: 900;
`;

type Suggestion =
    | undefined
    | {
          domain: string;
          username: string;
      };

export const EmailDomainSuggestion: React.FC<{ value: string | undefined }> = ({ value }) => {
    const [suggestion, setSuggestion] = useState<Suggestion>();

    useEffect(() => {
        const closestEmail = findClosestFullEmail(value);
        if (closestEmail) {
            setSuggestion(closestEmail);
        }
    }, [value]);

    return suggestion?.domain && suggestion?.username ? (
        <Suggestion>
            {TranslationHelpers.getFormattedMessage('suggestion.email', {
                suggestedDomain: <StrongText>{suggestion.domain}</StrongText>,
                emailUsername: `${suggestion.username}@`,
            })}
        </Suggestion>
    ) : null;
};
